import { BellRing } from "lucide-react";
import type { ProductionOperationalNotification } from "../models";
import { operatorNotificationMessage } from "../work-order-display";

export function OperationalNotificationStrip({
  items,
  mode,
}: {
  items: ProductionOperationalNotification[];
  mode: "operator" | "manager";
}) {
  const item = items[0];
  if (!item) return null;
  const label =
    mode === "operator"
      ? item.severity === "CRITICAL"
        ? "HEMEN İŞLEM YAPIN"
        : "GÖREV BİLDİRİMİ"
      : item.severity === "CRITICAL"
        ? "KRİTİK YÖNETİM SİNYALİ"
        : "YÖNETİM SİNYALİ";
  const visibleMessage = operatorNotificationMessage(item);
  return (
    <aside
      className={`operational-notification-strip is-${item.severity.toLowerCase()}`}
      aria-live="polite"
    >
      <span>
        <BellRing size={17} />
      </span>
      <div>
        <small>{label}</small>
        <strong>{visibleMessage}</strong>
      </div>
      <time dateTime={item.notifiedAt}>
        {new Intl.DateTimeFormat("tr-TR", {
          hour: "2-digit",
          minute: "2-digit",
        }).format(new Date(item.notifiedAt))}
      </time>
    </aside>
  );
}
